// Elorte-Medarić — kompletan katalog
// Opisi u stilu OLX oglasa. Bez tehničkih listi (features).
// coverIdx = koji broj slike (0-based) koristiti kao naslovnu (prednja strana ormara).

const g = (slug, files) => files.map((f) => `/gallery/${slug}/${f}`);

export const categories = [
  { key: "all", label: "Svi proizvodi" },
  { key: "kpmo", label: "KPMO" },
  { key: "kpo", label: "KPO" },
  { key: "grmo", label: "GRMO" },
  { key: "gradiliste", label: "Gradilište" },
  { key: "ostalo", label: "Ostalo" },
];

const desc = {
  outro:
    "Ormar se izrađuje po Vašim željama i prema uputstvima nadležne Elektrodistribucije. Moguća dostava na Vašu adresu (brza pošta). Za sve dodatne informacije i cijene slobodno nas kontaktirajte.",
};

// Formatiranje bloka sa specifikacijama (dimenzije, IP, napon...)
// specs = { sirina, visina, dubina, ip, napon, struja, verzija, dodatno }
const specsBlock = (s = {}) => {
  const lines = [];
  if (s.verzija) lines.push(`• Verzija: ${s.verzija}`);
  const dims = [];
  if (s.sirina) dims.push(`Širina ${s.sirina} mm`);
  if (s.visina) dims.push(`Visina ${s.visina} mm`);
  if (s.dubina) dims.push(`Dubina ${s.dubina} mm`);
  if (dims.length) lines.push(`• Dimenzije: ${dims.join(" × ")}`);
  if (s.ip) lines.push(`• Stepen zaštite: ${s.ip}`);
  if (s.napon || s.struja) {
    const en = [];
    if (s.napon) en.push(s.napon);
    if (s.struja) en.push(`max. ${s.struja}`);
    lines.push(`• Napon / struja: ${en.join(" – ")}`);
  }
  if (s.dodatno) s.dodatno.forEach((d) => lines.push(`• ${d}`));
  return lines.join("\n");
};

// Novi helper – opis + specs + outro
const olxDesc = (custom, specs) => {
  const parts = [custom];
  if (specs) parts.push(specsBlock(specs));
  parts.push(desc.outro);
  return parts.filter(Boolean).join("\n\n");
};

export const catalog = [
  // ========== KPMO family ==========
  {
    slug: "kpmo-0-0",
    name: "KPMO 0/0",
    short: "KPMO",
    category: "kpmo",
    coverIdx: 0,
    description: olxDesc(
      "Kućni priključno-mjerni ormar KPMO 0/0 za jedno brojilo od specijalizirane vakumirane PVC ploče, sa bravicom i 2 ključa. Namijenjen za individualne stambene objekte.",
      { verzija: "Ugradna – Podžbukna", sirina: 405, visina: 565, dubina: 160, ip: "IP54", napon: "400V", struja: "160A", dodatno: ["Sa bravicom i 2 ključa"] }
    ),
    images: g("kpmo-0-0", ["img-0.png", "img-1.png", "img-2.png", "img-3.png", "img-4.png"]),
  },
  {
    slug: "kpmo-00-0",
    name: "KPMO 00/0",
    short: "KPMO",
    category: "kpmo",
    coverIdx: 1,
    description: olxDesc(
      "Kompaktni priključno-mjerni ormar KPMO 00/0 za jedno mjerno mjesto. Idealan za manje objekte i vikendice."
    ),
    images: g("kpmo-00-0", ["img-0.png", "img-1.png", "img-2.png", "img-3.png", "img-4.png", "img-5.png"]),
  },
  {
    slug: "kpmo-1-0",
    name: "KPMO 1/0",
    short: "KPMO",
    category: "kpmo",
    coverIdx: 4,
    description: olxDesc(
      "Kućni priključno-mjerni ormar KPMO 1/0 za dva brojila, od specijalizirane vakumirane PVC ploče, sa bravicom i 2 ključa. Najčešće traženi model za individualne stambene objekte.",
      { verzija: "Ugradna – Podžbukna", sirina: 530, visina: 700, dubina: 210, ip: "IP54", napon: "400V", struja: "160A", dodatno: ["Sa bravicom i 2 ključa"] }
    ),
    images: g("kpmo-1-0", ["img-0.png", "img-1.png", "img-2.png", "img-3.png", "img-4.png"]),
  },
  {
    slug: "kpmo-1d-0",
    name: "KPMO 1D/0",
    short: "KPMO",
    category: "kpmo",
    coverIdx: 3,
    description: olxDesc(
      "Kućni priključno-mjerni ormar KPMO 1D/0 za jedno brojilo, od specijalizirane vakumirane PVC ploče, sa bravicom i 2 ključa.",
      { verzija: "Ugradna – Podžbukna", sirina: 370, visina: 760, dubina: 210, ip: "IP54", napon: "400V", struja: "160A", dodatno: ["Sa bravicom i 2 ključa"] }
    ),
    images: g("kpmo-1d-0", ["img-0.png", "img-1.png", "img-2.png", "img-3.png", "img-4.png"]),
  },
  {
    slug: "kpmo-1k-0",
    name: "KPMO 1K/0",
    short: "KPMO",
    category: "kpmo",
    coverIdx: 0,
    description: olxDesc(
      "Kućni priključno-mjerni ormar KPMO 1K/0 za dva brojila, od specijalizirane vakumirane PVC ploče, sa bravicom i 2 ključa.",
      { verzija: "Ugradna – Podžbukna", sirina: 540, visina: 540, dubina: 210, ip: "IP54", napon: "400V", struja: "160A", dodatno: ["Sa bravicom i 2 ključa"] }
    ),
    images: g("kpmo-1k-0", ["img-0.png", "img-1.png", "img-2.png", "img-3.png", "img-4.png"]),
  },
  {
    slug: "kpmo-1-3h",
    name: "KPMO 1/3H",
    short: "KPMO",
    category: "kpmo",
    coverIdx: 1,
    description: olxDesc(
      "Kućni priključno-mjerni ormar KPMO 1/3H za tri brojila, od specijalizirane vakumirane PVC ploče, sa bravicom i 2 ključa. Horizontalna izvedba za manje stambene zgrade.",
      { verzija: "Ugradna – Podžbukna", sirina: 700, visina: 530, dubina: 210, ip: "IP54", napon: "400V", struja: "160A", dodatno: ["Sa bravicom i 2 ključa"] }
    ),
    images: g("kpmo-1-3h", ["img-0.png", "img-1.png", "img-2.png", "img-3.png", "img-4.png"]),
  },
  {
    slug: "kpmo-2-0",
    name: "KPMO 2/0",
    short: "KPMO",
    category: "kpmo",
    coverIdx: 0,
    description: olxDesc(
      "Kućni priključno-mjerni ormar KPMO 2/0 za dva mjerna mjesta. Standardno rješenje za dvojne kuće, poslovne prostore i objekte sa dva korisnika.",
      { verzija: "Ugradna – Podžbukna", sirina: 640, visina: 820, dubina: 210, ip: "IP54", napon: "400V", struja: "160A" }
    ),
    images: g("kpmo-2-0", ["img-0.png", "img-1.png", "img-2.png", "img-3.png", "img-4.png"]),
  },
  {
    slug: "kpmo-3-0",
    name: "KPMO 3/0",
    short: "KPMO",
    category: "kpmo",
    coverIdx: 3,
    description: olxDesc(
      "Kućni priključno-mjerni ormar KPMO 3/0 za tri mjerna mjesta. Pogodan za višestambene i poslovne objekte.",
      { verzija: "Ugradna – Podžbukna", sirina: 790, visina: 820, dubina: 210, ip: "IP54", napon: "400V", struja: "160A" }
    ),
    images: g("kpmo-3-0", ["img-0.png", "img-1.png", "img-2.png", "img-3.png"]),
  },
  {
    slug: "kpmo-n0",
    name: "KPMO N0",
    short: "KPMO",
    category: "kpmo",
    coverIdx: 2,
    description: olxDesc(
      "Kućni priključno-mjerni ormar KPMO N 0/0 za jedno brojilo, od specijalizirane vakumirane PVC ploče, sa bravicom i 2 ključa.",
      { verzija: "Nadgradna – Nadžbukna", sirina: 290, visina: 405, dubina: 175, ip: "IP54", napon: "400V", struja: "160A", dodatno: ["Sa bravicom i 2 ključa"] }
    ),
    images: g("kpmo-n0", ["img-0.png", "img-1.png", "img-2.png", "img-3.png"]),
  },
  {
    slug: "kpmo-n1",
    name: "KPMO N1",
    short: "KPMO",
    category: "kpmo",
    coverIdx: 1,
    description: olxDesc(
      "Kućni priključno-mjerni ormar KPMO N1/0 za 2 brojila, od specijalizirane vakumirane PVC ploče, sa bravicom i 2 ključa. Najprodavaniji nadgradni model.",
      { verzija: "Nadgradna – Nadžbukna", sirina: 400, visina: 580, dubina: 175, ip: "IP54", napon: "400V", struja: "160A", dodatno: ["Sa bravicom i 2 ključa"] }
    ),
    images: g("kpmo-n1", ["img-0.png", "img-1.png", "img-2.png", "img-3.png", "img-4.png"]),
  },
  {
    slug: "kpmo-n1k",
    name: "KPMO N1K",
    short: "KPMO",
    category: "kpmo",
    coverIdx: 0,
    description: olxDesc(
      "Kućni priključno-mjerni ormar KPMO N1K/0 za dva brojila, od specijalizirane vakumirane PVC ploče, sa bravicom i 2 ključa.",
      { verzija: "Nadgradna – Nadžbukna", sirina: 405, visina: 405, dubina: 175, ip: "IP54", napon: "400V", struja: "160A", dodatno: ["Sa bravicom i 2 ključa"] }
    ),
    images: g("kpmo-n1k", ["img-0.png", "img-1.png", "img-2.png", "img-3.png", "img-4.png", "img-5.png"]),
  },

  // ========== KPO family ==========
  {
    slug: "kpo-ormar",
    name: "KPO ormar",
    short: "KPO",
    category: "kpo",
    coverIdx: 1,
    description: olxDesc(
      "Kućni priključni ormar (KPO) od specijalizirane vakumirane PVC ploče, sa bravicom i 2 ključa. Namijenjen za priključivanje na električnu mrežu bez mjerne garniture (sa glavnim osiguračima).",
      { verzija: "Ugradna", sirina: 405, visina: 415, dubina: 130, ip: "IP54", napon: "400V", struja: "160A", dodatno: ["Sa bravicom i 2 ključa"] }
    ),
    images: g("kpo-ormar", ["img-0.png", "img-1.png", "img-2.png", "img-3.png", "img-4.png"]),
  },
  {
    slug: "kpo-o",
    name: "KPO 0/0",
    short: "KPO",
    category: "kpo",
    coverIdx: 1,
    description: olxDesc(
      "Kućni priključni ormar KPO 0/0 od specijalizirane vakumirane PVC ploče, sa bravicom i 2 ključa.",
      { verzija: "Ugradna", sirina: 405, visina: 565, dubina: 160, ip: "IP54", napon: "400V", struja: "160A", dodatno: ["Sa bravicom i 2 ključa"] }
    ),
    images: g("kpo-o", ["img-0.png", "img-1.png", "img-2.png", "img-3.png", "img-4.png"]),
  },
  {
    slug: "kpo-00-0",
    name: "KPO 00/0",
    short: "KPO",
    category: "kpo",
    coverIdx: 0,
    description: olxDesc(
      "Kućni priključni ormar KPO 00/0 od specijalizirane vakumirane PVC ploče, sa bravicom i 2 ključa. Posjeduje sve potrebne certifikate i ateste.",
      { verzija: "Ugradna", sirina: 405, visina: 415, dubina: 130, ip: "IP54", napon: "400V", struja: "160A", dodatno: ["Sa bravicom i 2 ključa", "Certifikati i atesti"] }
    ),
    images: g("kpo-00-0", ["img-0.png", "img-1.png", "img-2.png", "img-3.png", "img-4.png"]),
  },
  {
    slug: "kpo-n0",
    name: "KPO N0",
    short: "KPO",
    category: "kpo",
    coverIdx: 2,
    description: olxDesc(
      "Kućni priključni ormar KPO N0 od specijalizirane vakumirane PVC ploče. Za priključivanje na električnu mrežu bez mjerne garniture.",
      { verzija: "Nadgradna – Nadžbukna (OG)", sirina: 290, visina: 405, dubina: 175, ip: "IP54", napon: "400V", struja: "160A" }
    ),
    images: g("kpo-n0", ["img-0.png", "img-1.png", "img-2.png", "img-3.png"]),
  },
  {
    slug: "kpo-n1",
    name: "KPO N1",
    short: "KPO",
    category: "kpo",
    coverIdx: 1,
    description: olxDesc(
      "Kućni priključni ormar KPO N1 od specijalizirane vakumirane PVC ploče. Najčešće korištena varijanta za stambene objekte.",
      { verzija: "Nadgradna – Nadžbukna", sirina: 400, visina: 580, dubina: 175, ip: "IP54", napon: "400V", struja: "160A" }
    ),
    images: g("kpo-n1", ["img-0.png", "img-1.png", "img-2.png", "img-3.png"]),
  },
  {
    slug: "kpo-n1k",
    name: "KPO N1K",
    short: "KPO",
    category: "kpo",
    coverIdx: 2,
    description: olxDesc(
      "Kućni priključni ormar KPO N1K od specijalizirane vakumirane PVC ploče, sa bravicom i 2 ključa.",
      { verzija: "Nadgradna – Nadžbukna", sirina: 405, visina: 405, dubina: 175, ip: "IP54", napon: "400V", struja: "160A", dodatno: ["Sa bravicom i 2 ključa"] }
    ),
    images: g("kpo-n1k", ["img-0.png", "img-1.png", "img-2.png", "img-3.png"]),
  },
  {
    slug: "kpo-n2",
    name: "KPO N2/0",
    short: "KPO",
    category: "kpo",
    coverIdx: 1,
    description: olxDesc(
      "Kućni priključni ormar KPO N2/0 za dva priključka, od specijalizirane vakumirane PVC ploče. Prostrana unutrašnjost za dvojne objekte.",
      { verzija: "Nadgradna – Nadžbukna (OG)", sirina: 800, visina: 800, dubina: 190, ip: "IP54", napon: "400V", struja: "160A" }
    ),
    images: g("kpo-n2", ["img-0.png", "img-1.png", "img-2.png", "img-3.png", "img-4.png", "img-5.png"]),
  },

  // ========== GRMO – NOVO ==========
  {
    slug: "grmo",
    name: "Glavni razvodni mjerni ormar (GRMO)",
    short: "GRMO",
    category: "grmo",
    coverIdx: 0,
    description: olxDesc(
      "GRMO – Glavni razvodni mjerni ormar za višestambene zgrade i poslovne objekte. Izrađuje se sa proizvoljnim brojem priključnih mjesta (xx – broj priključnih mjesta). Namijenjen je za priključivanje više korisnika električne energije na jednom mjestu. Prostrana unutrašnjost sa jasnim rasporedom mjernih mjesta, rastavljačkih sklopki i pomoćne opreme. Izrađuje se prema tehničkim uslovima nadležne Elektrodistribucije."
    ),
    images: g("grmo", ["img-0.jpg", "img-1.jpg", "img-2.jpg"]),
  },

  // ========== Gradilište ==========
  {
    slug: "gradilisni-ormar",
    name: "Gradilišni ormar",
    short: "GRAD",
    category: "gradiliste",
    coverIdx: 0,
    description: olxDesc(
      "Gradilišni ormar od najkvalitetnije specijalizirane PVC plastike, sa bravom i 2 ista ključa. Sadrži nosače pogodne za montažu na stub. Otporan na sve vremenske uslove, prašinu i mehanička oštećenja.",
      { verzija: "Nadgradna – Nadžbukna", sirina: 400, visina: 1000, dubina: 175, dodatno: ["Sa bravom i 2 ista ključa", "Nosači za montažu na stub"] }
    ),
    images: g("gradilisni-ormar", ["img-0.png", "img-1.png", "img-2.png", "img-3.png"]),
  },
  {
    slug: "gradilisni-ormar-samostojeci",
    name: "Gradilišni ormar – samostojeći",
    short: "GRAD",
    category: "gradiliste",
    coverIdx: 0,
    description: olxDesc(
      "Samostojeći gradilišni ormar sa integrisanim postoljem – spreman za teren, bez potrebe za dodatnom konstrukcijom. Otporan na atmosferske uticaje.",
      { sirina: 400, visina: 1000, dubina: 175 }
    ),
    images: g("gradilisni-ormar-samostojeci", ["img-0.png", "img-1.png", "img-2.png", "img-3.png", "img-4.png", "img-5.png"]),
  },
  {
    slug: "samostojeci-ormari",
    name: "Elektro ormari – samostojeći",
    short: "STOJI",
    category: "gradiliste",
    coverIdx: 0,
    description: olxDesc(
      "Elektro ormari – samostojeći, izrađeni od specijalizirane vakumirane PVC plastike debljine 3 mm, sa postoljem od željeza. Idealni za lokacije gdje ugradnja u zid nije moguća.",
      { dodatno: ["Dimenzije ormara: 300 × 400 mm, 400 × 400 mm ili 400 × 600 mm", "Visina postolja: 400 mm (željezo)", "PVC ploča debljine 3 mm"] }
    ),
    images: g("samostojeci-ormari", ["img-0.jpg", "img-1.jpg", "img-2.jpg", "img-3.jpg", "img-4.jpg", "img-5.jpg"]),
  },

  // ========== Ostalo ==========
  {
    slug: "prva-pomoc",
    name: "Ormar za prvu pomoć",
    short: "OPP",
    category: "ostalo",
    coverIdx: 1,
    description: olxDesc(
      "Ormar za prvu pomoć – za pohranu i čuvanje seta za pružanje prve pomoći. Nadžbuk izvedba, jednostavna montaža na zid. Obavezan dio opreme u radnim prostorima i firmama.",
      { visina: 400, sirina: 290, dubina: 175 }
    ),
    images: g("prva-pomoc", ["img-0.png", "img-1.png", "img-2.png", "img-3.png"]),
  },
  {
    slug: "antenski-ormaric",
    name: "Antenski ormarić",
    short: "ANT",
    category: "ostalo",
    coverIdx: 3,
    description: olxDesc(
      "Antenski ormarić od specijalizirane plastike sa nehrđajućim inox vijcima. Zaštita razvodne opreme za TV i SAT signale, otporan na atmosferske uticaje.",
      { visina: 215, sirina: 140, dodatno: ["Nehrđajući inox vijci"] }
    ),
    images: g("antenski-ormaric", ["img-0.png", "img-1.png", "img-2.png", "img-3.png"]),
  },
  {
    slug: "postanski-ormaric",
    name: "Poštanski ormarić",
    short: "POŠ",
    category: "ostalo",
    coverIdx: 1,
    description: olxDesc(
      "Poštanski ormarić od specijalizirane plastike otporne na atmosferske uticaje, sa nehrđajućim inox vijcima. Za prijem pošiljki.",
      { visina: 300, sirina: 215, dodatno: ["Nehrđajući inox vijci", "Otporno na atmosferske uticaje"] }
    ),
    images: g("postanski-ormaric", ["img-0.png", "img-1.png", "img-2.png", "img-3.png"]),
  },
  {
    slug: "telefonski-ormaric",
    name: "Telefonski ormarić",
    short: "TEL",
    category: "ostalo",
    coverIdx: 3,
    description: olxDesc(
      "Telefonski ormarić od specijalizirane plastike, sa nehrđajućim inox vijcima i bravicom sa 2 ključa. Za zaštitu telefonske i komunikacijske razvodne opreme.",
      { visina: 215, sirina: 140, dubina: 80, dodatno: ["Nehrđajući inox vijci", "Sa bravicom i 2 ključa"] }
    ),
    images: g("telefonski-ormaric", ["img-0.png", "img-1.png", "img-2.png", "img-3.png"]),
  },
  {
    slug: "kms",
    name: "KMS ormarić",
    short: "KMS",
    category: "ostalo",
    coverIdx: 0,
    description: olxDesc(
      "KMS ormarić – kombinovani modul za specifične namjene sa mogućnošću prilagodbe zahtjevima korisnika. Univerzalno rješenje kada je potreban prilagodljiv modul."
    ),
    images: g("kms", ["img-0.png", "img-1.png", "img-2.png", "img-3.png", "img-4.png", "img-5.png"]),
  },
];

export const featured = [
  "kpmo-n1",
  "kpo-ormar",
  "grmo",
  "prva-pomoc",
];

export const atestImages = ["/atest/atest-1.jpg", "/atest/atest-2.jpg"];

// Helper – vrati "cover" sliku (prednja strana ormara)
// Prvo provjeri localStorage (korisnik može promijeniti naslovnu iz modala),
// pa onda coverIdx iz kataloga, pa fallback na prvu sliku.
export function coverOf(product) {
  if (typeof window !== "undefined") {
    try {
      const overrides = JSON.parse(localStorage.getItem("elorte_covers") || "{}");
      const oi = overrides[product.slug];
      if (typeof oi === "number" && oi >= 0 && oi < product.images.length) {
        return product.images[oi];
      }
    } catch (_) {}
  }
  const idx = Math.min(product.coverIdx ?? 0, product.images.length - 1);
  return product.images[idx];
}

export function setCoverOverride(slug, imageIdx) {
  if (typeof window === "undefined") return;
  try {
    const overrides = JSON.parse(localStorage.getItem("elorte_covers") || "{}");
    overrides[slug] = imageIdx;
    localStorage.setItem("elorte_covers", JSON.stringify(overrides));
  } catch (_) {}
}

export function getCoverOverride(slug) {
  if (typeof window === "undefined") return null;
  try {
    const overrides = JSON.parse(localStorage.getItem("elorte_covers") || "{}");
    return typeof overrides[slug] === "number" ? overrides[slug] : null;
  } catch (_) {
    return null;
  }
}
